/* global safari */

export default function validateNumberInputs() {
  var isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === '[object SafariRemoteNotification]';
    })(
      !window['safari'] ||
        (typeof safari !== 'undefined' && safari.pushNotification),
    );

  if (isSafari) {
    document.addEventListener('change', function () {
      document
        .querySelectorAll('input[type="number"]')
        .forEach(function (input) {
          checkForSingleSeparator(input);
        });
    });
  }
}

function checkForSingleSeparator(input) {
  var val = input.value;
  if (
    val.charAt(val.length - 1) === '.' ||
    val.charAt(val.length - 1) === ','
  ) {
    input.setCustomValidity('Please end input with number value');
  } else {
    input.setCustomValidity('');
  }
}
